export enum SocialMedia {
  Facebook = "facebook",
  Twitter = "twitter",
  Whatsapp = "whatsapp",
  Snapchat = "snapchat",
  Telegram = "telegram",
}
